import { AccessoryTabProps } from 'components/desktop/Accessory/AccessoryComponent';
import { AccessoryCategoriesCard } from 'components/desktop/Accessory/Cards/AccessoryCategoriesCard';
import { AccessoryCharacteristicsCard } from 'components/desktop/Accessory/Cards/AccessoryCharacteristicsCard';
import { AccessoryDensityCard } from 'components/desktop/Accessory/Cards/AccessoryDensityCard';
import { AccessoryPriceCard } from 'components/desktop/Accessory/Cards/AccessoryPriceCard';
import { AccessoryTagsCard } from 'components/desktop/Accessory/Cards/AccessoryTagsCard';
import { AccessoryUnitWeightsCard } from 'components/desktop/Accessory/Cards/AccessoryUnitWeightsCard';

const TabMetadata = ({ state, handlers, data }: AccessoryTabProps) => {
	return (
		<div className="row mt-4">
			<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
				<AccessoryCharacteristicsCard state={state} handlers={handlers} data={data} />
				<AccessoryDensityCard state={state} handlers={handlers} data={data} />
				<AccessoryPriceCard state={state} handlers={handlers} data={data} />
			</div>
			<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
				<AccessoryTagsCard state={state} handlers={handlers} data={data} />
				<AccessoryCategoriesCard state={state} handlers={handlers} data={data} />
			</div>
			<div className="col-4 d-flex flex-column" style={{ gap: '15px' }}>
				<AccessoryUnitWeightsCard state={state} handlers={handlers} data={data} />
			</div>
		</div>
	);
};

export default TabMetadata;
